import React from 'react';
import { useSelector } from 'hooks';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';

import { getQRCode } from 'modules/restrictedAccess/selectors';

import { Button, Image } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

type QRCodeProps = {
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void
};

const QRCode: React.FC<QRCodeProps> = ({ onCancel }) => {
  const qrCodeMedia = useSelector(getQRCode);

  return (
    <>
      <div className="text-center [&>p]:inline [&>p]:mx-1">
        <FormattedMessage
          id="restrictedAccess.modal.description"
          tagName="p"
          defaultMessage="Outside the dealership's opening hours, access to the kiosk may be restricted by a gate."
        />
        <FormattedMessage
          id="restrictedAccess.modal.qrcodeDescription"
          tagName="p"
          values={{ b }}
          defaultMessage="In this case, <b>scan the QR code</b> on its reader."
        />
      </div>
      <div className="flex justify-center">
        <Image src={qrCodeMedia.path} className="overflow-hidden bg-input-bg p-s rounded-3xl max-w-1/2-screen [&>img]:rounded-lg" />
      </div>
      <Button type={ButtonType.TERTIARY} onClick={onCancel} testId="continue-btn">
        <FormattedMessage id="socket.modal.confirm" defaultMessage="Continue" />
      </Button>
    </>
  );
};

export default QRCode;
